import { Wizard } from '../../components/Wizard';
import { Loading } from '../../components/Loading';

import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { useResolvableServiceUsageSteps } from './hooks/useSteps.hook';
import { useResolvableServiceUsageSchema } from './hooks/useResolvableServiceUsageSchema.hook';
import type { Props } from './types/props.type';

export const ResolvableServiceUsageForm = ({
  askMemoBeforeSubmit = true,
  documentResolversSettings,
  excludedIds,
  formVariant,
  index,
  initialValues: pInitialValues,
  onCancel: handleCancel,
  onSubmit: handleSubmit,
  resolvableFieldSettings,
  serviceUsageOrigin,
  setMustBlockAction,
  showCancelButton,
  stepIdsSubset,
  storage,
  title,
}: Readonly<Props>) => {
  const { initialValues } = useInitialValuesFactory({
    index,
    initialValues: pInitialValues,
    serviceUsageOrigin,
  });

  const { isLoading, steps, wizardChildren } = useResolvableServiceUsageSteps({
    documentResolversSettings,
    excludedIds,
    initialValues,
    resolvableFieldSettings,
    stepIdsSubset,
    storage,
  });

  const ResolvableServiceUsageSchema = useResolvableServiceUsageSchema();

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!isLoading && <Loading />}
      <Wizard
        ValidationSchema={ResolvableServiceUsageSchema}
        askMemoBeforeSubmit={askMemoBeforeSubmit}
        formTitle={title}
        formVariant={formVariant}
        initialValues={initialValues}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        setMustBlockAction={setMustBlockAction}
        showCancelButton={showCancelButton}
        steps={steps}
      >
        {wizardChildren}
      </Wizard>
    </>
  );
};
